export const STATUS_COLORS = {
  planned: { bg: '#fef08a', border: '#ca8a04', label: 'Wstępnie zaplanowany' },
  pre_assigned: { bg: '#ffffff', border: '#94a3b8', label: 'Wstępnie przypisany' },
  quick_add: { bg: '#fed7aa', border: '#ea580c', label: 'Szybki montaż' },
  calendar_note: { bg: '#e0f2fe', border: '#0284c7', label: 'Notatka' },
  additional_work: { bg: '#ede9fe', border: '#7c3aed', label: 'Dodatkowa praca' },
  team_assigned: { bg: '#fef08a', border: '#ca8a04', label: 'Wstępnie zaplanowany' },
  confirmed: { bg: '#bbf7d0', border: '#15803d', label: 'Potwierdzony u klienta' },
  signed: { bg: '#bbf7d0', border: '#000000', label: 'Podpisane dokumenty' },
  complaint: { bg: '#bbf7d0', border: '#b91c1c', label: 'Reklamacja' },
};

export const REGULAR_STATUSES = [
  'pre_assigned',
  'planned',
  'quick_add',
  'additional_work',
  'confirmed',
];

export const FINAL_STATUSES = ['signed', 'complaint'];

export function installationStatusLabel(status) {
  if (!status) return '—';
  return STATUS_COLORS[status]?.label || status;
}
